"use client"

const ProductCard = ({ id, type, data, product }) => {
  return (
    <div className="my-5 flex w-full flex-col justify-start rounded-lg bg-white p-5 shadow-[0_2px_10px_-2px_rgba(0,0,0,0.3)]">
      <div className="text-lg font-bold ml-3 mb-2">{product.name}</div>
      <div className="text-home-gray_1 ml-3 mb-2">{product.description}</div>
      <div>
        <div className="inline-flex rounded-3xl bg-home-orange_1 px-4 py-2 text-white">
          Get Your eSIM for Only $1.99
        </div>
      </div>
    </div>
  )
}

export default ProductCard
